import { type ComponentPropsWithRef, type ReactElement } from 'react'

import { ContentWrapper } from '@components/ui-core/content-wrapper/content-wrapper'
import { type Picture } from '@components/ui-core/picture/picture'

import styles from './section.module.scss'

export type SectionProps = ComponentPropsWithRef<'section'> & {
  backgroundImage?: ReactElement<typeof Picture>
}

export function Section(props: SectionProps): ReactElement {
  const { className, children, backgroundImage, ...rest } = props

  return (
    <section className={styles.section} {...rest}>
      {backgroundImage && <div className={styles.background}>{backgroundImage}</div>}
      <ContentWrapper className={className}>{children}</ContentWrapper>
    </section>
  )
}
